<template>
  <div class="w-full">
    <template v-if="users.length">

      <!-- Mobile: card list -->
      <div class="sm:hidden divide-y divide-gray-200">
        <div
          v-for="(user, i) in users"
          :key="i"
          class="flex items-center justify-between px-4 py-3"
          :class="{ 'bg-primary-100': i % 2 === 0 }"
        >
          <div class="flex items-center space-x-3 min-w-0">
            <div class="flex-shrink-0 w-10 h-10 rounded-full bg-primary-600 flex items-center justify-center text-white font-bold text-sm uppercase">
              {{ user.name ? user.name[0] : '?' }}
            </div>
            <div class="min-w-0">
              <p class="font-semibold text-sm truncate">{{ user.name }}</p>
              <p class="text-xs text-gray-500 truncate">{{ user.email }}</p>
            </div>
          </div>
          <div class="flex items-center space-x-2 flex-shrink-0 ml-3">
            <BaseSwitch
              :value="user.active"
              @input="handleSwitchInput"
              @on="handleSwitchOn(user)"
              @off="handleSwitchOff(user)"
            />
            <button
              type="button"
              class="rounded-full focus:outline-none focus:ring"
              @click="handlerEdit(user)"
            >
              <i class="tmlps-i-edit-circle text-3xl h-8 w-8"></i>
            </button>
            <button
              type="button"
              class="rounded-full focus:outline-none focus:ring"
              @click="handlerDelete(user)"
            >
              <i class="tmlps-i-delete-circle text-3xl h-8 w-8"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Desktop: table -->
      <table class="hidden sm:table min-w-full">
        <thead>
          <tr>
            <th scope="col" class="px-6 py-3 text-left">Nombre de usuario</th>
            <th scope="col" class="px-6 py-3 text-left">Correo</th>
            <th scope="col" class="px-6 py-3 text-left">Estatus</th>
            <th scope="col" class="px-6 py-3 text-left"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(user, i) in users" :key="i" :class="{ 'bg-primary-100': i % 2 === 0 }">
            <td scope="col" class="px-6 py-3 text-left">{{ user.name }}</td>
            <td scope="col" class="px-6 py-3 text-left">{{ user.email }}</td>
            <td scope="col" class="px-6 py-3 text-left">
              <BaseSwitch
                :value="user.active"
                @input="handleSwitchInput"
                @on="handleSwitchOn(user)"
                @off="handleSwitchOff(user)"
              />
            </td>
            <td scope="col" class="px-6 py-3 text-right space-x-4">
              <button
                type="button"
                class="rounded-full focus:outline-none focus:ring"
                @click="handlerEdit(user)"
              >
                <i class="tmlps-i-edit-circle text-3xl h-8 w-8"></i>
              </button>
              <button
                type="button"
                class="rounded-full focus:outline-none focus:ring"
                @click="handlerDelete(user)"
              >
                <i class="tmlps-i-delete-circle text-3xl h-8 w-8"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>

    </template>
    <template v-else>
      <div class="flex flex-col items-center mt-8 px-4">
        <img
          src="/img/search-no-results.png"
          alt="no-records"
          class="w-full max-w-xs object-contain"
        />
        <h2 class="text-xl text-center -mt-10">
          No hay usuarios registrados por el momento
        </h2>
      </div>
    </template>
  </div>
</template>

<script>
import BaseSwitch from '@/components/BaseSwitch';
export default {
  name: 'users-table',
  props: {
    users: { type: Array, default: null },
  },
  components: { BaseSwitch },
  methods: {
    handlerDelete(user) {
      this.$emit('delete-user', user);
    },
    handlerEdit(user) {
      this.$emit('edit-user', user);
    },
    async handleSwitchOn(user) {
      const form = new FormData();
      form.append('user_id', user.id);
      await this.$store.dispatch('tenant/enableUser', form);
      this.$emit('reload-records', true);
    },
    handleSwitchOff(user) {
      this.$emit('disable-user', user);
    },
    handleSwitchInput() {},
  },
};
</script>
